import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { AppContext } from "../context/AppContext";
import { ReportService } from "../services/ReportsService";
import { useCurrentAccount } from "../hooks/useCurrentAccount";
import { AlertService } from "../services/Alert";
import { DateUtil } from "../utils/date";
import { ChannelUtil } from "../utils/channel";
import { MessageUtil } from "../utils/message";
import { useForm } from "react-hook-form";
import Button from "./form-controls/Button";
import ModalNewConversation from "./ModalNewConversation";
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import Message from "./Message";
import useRequest from "../hooks/useRequest";
import Loader from "./Loader";
import LoaderSmall from "./LoaderSmall";
import { t } from "i18next";

declare const bootstrap: any;

function Ticket() {

    const ref = useRef<HTMLDivElement>()
    const refMessages = useRef<HTMLDivElement>()
    const { account } = useCurrentAccount();
    const{call: callTickets,isRequesting: isRequestingTickets} = useRequest();
    const{call: callCustomer,isRequesting: isRequestingCustomer} = useRequest();
    const { showTicketDetail, setShowTicketDetail, setShowCustomerDetail } = useContext(AppContext);
    const [logsInfo, setLogsInfo] = useState(null);

    const defaultValues = {
        category: '',
        observations: ''
    }
    const handleCategory = useForm<typeof defaultValues>({
        mode: 'onChange',
        defaultValues
    });

    const [editCategory, setEditCategory] = useState(false)
    const [conversations, setConversations] = useState([])
    const [form, setForm] = useState([])
    const [ticket, setTicket] = useState(null)
    const [customer, setCustomer] = useState(null)

    const [modalNewConversation, setModalNewConversation] = useState(false)

    const initialsCustomer = useMemo(() => {
        if (!ticket?.name_client) return;

        return ticket.name_client[0].toUpperCase()
    }, [ticket])

    const copyToClipboard = async (text) => {
        await navigator.clipboard.writeText(text);

        AlertService.toastSuccess('Texto copiado', 2000)
    }

    const downloadDocument = async (url) => {
        await AlertService.warning('Descargar archivo', '¿Te gustaría realizar la descarga de este archivo?', async () => {
            try {
                window.open(url, '_blank');
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al descargar el archivo, intenta nuevamente')
            }
        });
    }

    const updateCategory = async (data) => {
        if (!data.observations?.trim()) {
            AlertService.error('¡Error!', 'Las observaciones son requeridas')
            return;
        }

        try {
            await ReportService.updateCategoryTicket(account.id, ticket.id, {
                category: data.category,
                observations: data.observations
            })
            AlertService.toastSuccess('Se actualizó correctamente la categoría')
            setEditCategory(false)
        } catch (error) {
            console.error(error)
            AlertService.error('¡Error!', 'Ocurrió un error al actualizar la categoría, intenta nuevamente')
        }
    }

    const getTicketDetail = async () => {
        console.log(showTicketDetail)

        const { data } = await callTickets(()=> ReportService.getTicketDetail(account.id, showTicketDetail.ticketID));
        setConversations(data.conversation.reverse())
        setLogsInfo(data.logs_trasaccion);
        setTicket(data.ticket)
        handleCategory.setValue('category', data?.ticket?.categoria || '')
        handleCategory.setValue('observations', data?.ticket?.observations || '')

        if (data.form && Array.isArray(data.form)) {
            let form = data.form
                .map(f => {
                    const key = Object.keys(f)[0]

                    return {
                        key,
                        value: f[key]
                    }
                })
                .filter(f => f.key !== 'form_id')

            setForm(form)
        }
    }

    const handleStatusCustomer = async () => {
        const title = customer.blocked ? 'Desbloquear cliente' : 'Bloquear cliente';
        const message = customer.blocked ? '¿Estas seguro de querer desbloquear a este cliente?' : '¿Estas seguro de querer bloquear a este cliente?';

        await AlertService.warning(title, message, async () => {
            try {
                if (customer.blocked) {
                    await ReportService.unblockCustomer(account.id, ticket.account_client_id)
                } else {
                    await ReportService.blockCustomer(account.id, ticket.account_client_id)
                }

                await getCustomerInfo()

                AlertService.toastSuccess('Se cambió correctamente el estatus del cliente.')
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al cambiar el estatus del cliente, intenta nuevamente')
            }
        });
    }

    const getCustomerInfo = async () => {
        const { data } = await callCustomer(() => ReportService.getCustomerInfo(account.id, ticket.account_client_id));
        setCustomer(data)
    }

    const downloadMessages = async () => {
        
        const canvas = await html2canvas(refMessages.current, {
            backgroundColor: '#f9fafc',
            onclone: (document: Document, element: HTMLElement) => element.classList.remove('overflow-scroll')
        })

        const image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");

        const link = document.createElement('a')
        link.setAttribute('download', `${ticket.id}.png` );
        link.setAttribute('href', canvas.toDataURL("image/png").replace("image/png", "image/octet-stream"));
        link.click();
       
    }

    useEffect(() => {
        if (ticket && ticket.account_client_id) {
            getCustomerInfo()
            handleCategory.setValue('category', ticket?.categoria || '');
            handleCategory.setValue('observations', ticket?.observations || '');
        }
    }, [ticket])

    useEffect(() => {
        let instance = bootstrap.Offcanvas.getOrCreateInstance(ref.current)

        if (!instance) return

        if (showTicketDetail.show) {
            instance.show()
        } else {
            instance.hide()

            setConversations([])
            setForm([])
            setTicket(null)
            setEditCategory(false)
            setCustomer(null)
        }

    }, [showTicketDetail.show])


    useEffect(() => {
        if (showTicketDetail.ticketID && showTicketDetail.show) {
            getTicketDetail()
        }
    }, [showTicketDetail.ticketID, showTicketDetail.show])

    useEffect(() => {
        let instance = bootstrap.Offcanvas.getOrCreateInstance(ref.current)


        if(ref.current) {
            ref.current.addEventListener('hidden.bs.offcanvas', () => {
                setShowTicketDetail(s => ({ ...s, show: false }))
            })

        }

        const handleCloseOffcanvas = (event) => {
            const existsZoomOverlay = document.getElementsByClassName('zoom-overlay')
            if(event.key === 'Escape' && !existsZoomOverlay.length) {
                instance.hide()
            }
        }

        ref.current.addEventListener('keyup', handleCloseOffcanvas)
      

        return () => {
            if (instance) instance.hide()

            if(ref.current) ref.current.removeEventListener('keyup', handleCloseOffcanvas)
            
        }
    }, [])
    
    const heightRequesting = useMemo(() => { return isRequestingTickets ? 'h-110':''},[isRequestingTickets]);
    return (
        <>
            <div className="offcanvas offcanvas-end" ref={ref} style={{ width: '70%' }}  tabIndex={-1} id="staticBackdrop" aria-labelledby="staticBackdropLabel" data-bs-keyboard="false">

                <div className="offcanvas-body p-0 overflow-hidden">
                    <div className="row g-0 h-100">
                        <div className="col-8 h-100">
                            <div className="bg-light border h-100 d-flex flex-column">

                                <div className={`bg-white border-bottom shadow-sm p-3 relative ${heightRequesting}`}>
                                    {
                                        isRequestingTickets ? <LoaderSmall/> :
                                    <div className="d-flex align-items-center">

                                        <button type="button" className="btn btn-ghost-light btn-back text-dark btn-icon me-2" onClick={() => (setShowTicketDetail(s => ({ ...s, show: false })))}>
                                            <i className="bi-arrow-left"></i>
                                        </button>


                                        <span className="avatar avatar-primary avatar-circle">
                                            <span className="avatar-initials">{initialsCustomer}</span>
                                        </span>
                                        <div className="ms-2 ">
                                            <h4 className="mb-0">{ticket?.name_client}</h4>
                                            <p className="m-0 form-text">{ticket?.numero_entrada?.slice(0, -5)}</p>
                                        </div>

                                        <div className="ms-auto">

                                            <button className="btn bg-soft-primary btn-sm  border" onClick={downloadMessages}>
                                                <i className="bi-download"></i> Descargar mensajes
                                            </button>
                                        </div>
                                    </div>
                                    }
                                </div>

                                <div className="p-3 flex-grow-1 d-flex flex-column-reverse overflow-scroll relative" ref={refMessages}>

                                    { (isRequestingTickets) ? <Loader/> : conversations.map( conversation => <Message key={conversation.id} message={conversation} ticket={ticket} />)}

                                </div>
                                {
                                    isRequestingTickets ? <></> :
                                <div className="bg-white border-top shadow-sm p-3">
                                    <div className="text-center">
                                        <p className="h5">No puedes enviar mensajes en esta conversación</p>
                                        <p className="small">Una vez que un ticket ha sido cerrado, no es posible enviar mensajes. Si necesitas enviar un mensaje, por favor genera una nueva conversación reabriendo el ticket.</p>

                                        <div className="d-grid">
                                            <button className="btn btn-soft-primary text-white-dark" onClick={() => setModalNewConversation(true)}>Reabrir ticket</button>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                        <div className="col-4 h-100 relative">
                            {
                                isRequestingTickets ? <Loader/>:
                            <div className="text-center h-100 overflow-scroll">

                                <div className="pt-5 bg-white ticket-info-header border-bottom">

                                    <div>
                                        <span className="avatar avatar-xl avatar-primary avatar-circle">
                                            <span className="avatar-initials">{initialsCustomer}</span>
                                        </span>
                                    </div>
                                    <h3 className="mt-3">{ticket?.name_client}</h3>
                                    <p className="form-text m-0"><i className="bi-telephone me-1"></i> {ticket?.numero_entrada?.slice(0, -5)}</p>

                                    <div className="d-flex justify-content-center my-5">

                                        <div>
                                            <button className="btn bg-soft-primary icon icon-circle mb-2 " onClick={handleStatusCustomer}>
                                                {customer?.blocked ? <i className="bi-lock"></i> : <i className="bi-unlock"></i>}
                                            </button>
                                            <p className="form-text m-0">{customer?.blocked ? 'Desbloquear' : 'Bloquear'}</p>
                                        </div>

                                        <div className="ms-3">
                                            <button className="btn bg-soft-primary icon icon-circle mb-2" onClick={() => setShowCustomerDetail({ account_client_id: ticket.account_client_id, show: true })}>
                                                <i className="bi-pencil"></i>
                                            </button>
                                            <p className="form-text m-0">Editar</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-3">

                                    <div className="p-3 text-start">
                                        <h4>Categoría de cierre</h4>
                                        <p className="">Puedes actualizar la categoría de cierre de este ticket para ajustarla a una categoría más adecuada</p>
                                        <div className="mb-5">

                                            <div className="input-group input-group-sm input-group-merge table-input-group">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Seleccionar o escribir categoría"
                                                    list="categories"
                                                    {...handleCategory.register('category', { 
                                                        required: true,
                                                        onChange: (e) => {
                                                            // Solo actualizar el valor del formulario, sin actualizar en el backend
                                                            handleCategory.setValue('category', e.target.value);
                                                        }
                                                    })}
                                                />
                                                <datalist id="categories">
                                                    {showTicketDetail.categories?.map((category: string, index: number) => (
                                                        <option key={index} value={category} />
                                                    ))}
                                                </datalist>
                                                <button 
                                                    className="btn btn-primary"
                                                    type="button"
                                                    onClick={() => {
                                                        const formData = handleCategory.getValues();
                                                        if (!formData.observations?.trim()) {
                                                            AlertService.error('¡Error!', 'Las observaciones son requeridas');
                                                            return;
                                                        }
                                                        handleCategory.handleSubmit(updateCategory)();
                                                    }}
                                                >
                                                    <i className="bi-check-lg"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Observaciones</label>
                                            <textarea 
                                                className="form-control" 
                                                rows={3}
                                                placeholder="Ingresa las observaciones"
                                                {...handleCategory.register('observations' as keyof typeof defaultValues, { 
                                                    required: true,
                                                    validate: value => value?.trim()?.length > 0 || 'Las observaciones son requeridas'
                                                })}
                                            />
                                            {handleCategory.formState.errors.observations && (
                                                <div className="invalid-feedback d-block">
                                                    {handleCategory.formState.errors.observations.message}
                                                </div>
                                            )}
                                        </div>

                                        <hr />


                                        <h4>Formulario de cierre</h4>
                                        <p className="mb-5">La siguiente información corresponde al momento de cierre de este ticket</p>

                                        {
                                            form.length === 0 && (
                                                <div className="alert alert-warning" role="alert">
                                                    <div className="d-flex">
                                                        <i className="bi-exclamation-circle h1 mb-0 me-2"></i>
                                                        <p className="m-0">Este ticket no cuenta con formulario de cierre</p>
                                                    </div>
                                                </div>
                                            )
                                        }

                                        {
                                            form.map((row, index) => (
                                                <div className="mb-3" key={index}>
                                                    <label className="form-label">{row.key} </label>
                                                    <div className="input-group input-group-sm input-group-merge table-input-group">
                                                        <input type="text" className="form-control" value={row.value} readOnly />
                                                        <button className="js-clipboard input-group-append input-group-text" onClick={() => copyToClipboard(row.value)}><i className="bi-clipboard"></i></button>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                                <>
                                                    {(logsInfo && logsInfo?.length) > 0 &&
                                                        <div className="border-top">
                                                            <h4 className="mt-3">Historial del ticket</h4>
                                                            <p>Se muestra la información de los movimientos relacionados con el ticket cerrado.</p>
                                                            {logsInfo && logsInfo?.length > 0 ? (
                                                                logsInfo?.map((log, index) => (
                                                                    <div key={index} className="mt-3">
                                                                        <p className="m-0"><strong>Fecha:</strong> {log?.date.split(' ')[0]}</p>
                                                                        <p className="m-0"><strong>Hora:</strong> {log?.date.split(' ')[1]}</p>
                                                                        <p className="m-0"><strong>Descripción:</strong> {log?.log_text}</p>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                null
                                                            )}
                                                        </div>
                                                    }
                                                </>  
                                    </div>
                                </div>

                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <ModalNewConversation
                show={modalNewConversation}
                customer_number={ticket?.numero_entrada?.slice(0, -5)}
                ticket_id={ticket?.id}
                onRequestClose={() => setModalNewConversation(false)}
            />

        </>
    )
}
export default Ticket